import { render, staticRenderFns } from "./VideoStatusBadge.vue?vue&type=template&id=7a9b79d4&"
import script from "./VideoStatusBadge.vue?vue&type=script&lang=js&"
export * from "./VideoStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports